<template>
    <div class="competitive-analysis-report">
        <KeepAlive>
            <SelectTargetCompany
                v-if="currentStep.stepNum === 2"
                heading="Select Target Company"
                sub-heading=""
            />
        </KeepAlive>
        <KeepAlive>
            <div
                class="tech-area-holder h-100 display-flex flex-column"
                v-if="currentStep.stepNum === 3"
            >
                <h5>Select Technology Areas</h5>
                <AonCard class="mt-md h-100">
                    <div class="content-holder h-100">
                        <SelectTechAreas
                            v-if="allTechAreas"
                            :table-data="allTechAreas"
                            :loading="false"
                            :report-step="3"
                            type="report"
                        />
                    </div>
                </AonCard>
            </div>
        </KeepAlive>
        <KeepAlive>
            <ContenderSelectionTrack v-if="currentStep.stepNum === 4" />
        </KeepAlive>
        <KeepAlive>
            <ReportSummary :key="updater" v-if="currentStep.stepNum === 5" />
        </KeepAlive>
        <TechnologyDrillInModal v-if="entityStore.showDrillIn || arenaOutputStore.showDrillIn" />
    </div>
</template>

<script setup>
import { ref, watch, onMounted, nextTick, computed } from 'vue'
import {
    useReportGenerationStore,
    useMoat2ProductStore,
    useArenaOutputStore,
    useEntityStore,
} from '@/stores'
import { useRouter } from 'vue-router'

import SelectTargetCompany from '@/components/reports/shared/SelectTargetCompany.vue'
import { default as SelectTechAreas } from '@/components/alignmentOutput/techAreas/OutputTechAreaTable.vue'
import ContenderSelectionTrack from '@/components/reports/reportTypes/competitiveAnalysis/ContenderSelectionTrack.vue'
import ReportSummary from '@/components/reports/shared/ReportSummary.vue'

import TechnologyDrillInModal from '@/components/company/drillIn/TechnologyDrillInModal.vue'

const reportGenerationStore = useReportGenerationStore()
const moat2ProductStore = useMoat2ProductStore()
const arenaOutputStore = useArenaOutputStore()
const entityStore = useEntityStore()
const router = useRouter()

const updater = ref(0)
const source = ref(null)

onMounted(async () => {
    await nextTick()
})

watch(
    () => reportGenerationStore.reportSelections,
    (newVal, oldVal) => {
        updater.value++
    },
    { deep: true }
)

watch(
    () => reportGenerationStore.reportSelections[2]?.value,
    (newVal, oldVal) => {
        if (!oldVal && newVal) {
            reportGenerationStore.flagForContenderUpdate()
        }

        if (oldVal && newVal && newVal.length !== oldVal.length) {
            reportGenerationStore.flagForContenderUpdate()
            reportGenerationStore.onTechAreaChange()
        }
    },
    { deep: true }
)

watch(
    () => router,
    (newVal, oldVal) => {
        source.value = newVal.currentRoute.value.query.source
    },
    { flush: 'pre', immediate: true, deep: true }
)

const currentStep = computed(() => {
    return reportGenerationStore.getCurrentStep()
})

const allTechAreas = computed(() => {
    return reportGenerationStore.techAreaNodes
})
</script>

<style lang="scss" scoped>
.competitive-analysis-report {
    height: 100%;
    width: 100%;
}
</style>
